module.exports = __webpack_public_path__ + "assets/img/5252-im.svg";